import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const editCustomPanelMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Edit Panel Size',
		onClick: ({ context, controller }): void => {
			controller.publishRequestedAction('edit_custom_panel', context.id);
		}
	};
};
